import { effect, signal } from "@preact/signals";

/** User's stored preference. "system" defers to prefers-color-scheme. */
export type ThemePref = "system" | "dark" | "light";

const STORAGE_KEY = "dictionDojo.theme";

function readStored(): ThemePref {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "dark" || v === "light" || v === "system") return v;
  } catch {
    /* storage unavailable — fall through to default */
  }
  return "system";
}

export const themePref = signal<ThemePref>(readStored());

export function setThemePref(pref: ThemePref) {
  themePref.value = pref;
  try {
    localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    /* storage unavailable — theme still applies for this session */
  }
}

if (typeof document !== "undefined") {
  effect(() => {
    const pref = themePref.value;
    const root = document.documentElement;
    if (pref === "system") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", pref);
  });
}
